import type { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { ShellChrome } from '@/layouts/shellChrome';

const PARENT = {
  Home: '/clinic-manager/today',
  Reports: '/clinic-manager/reports',
  Settings: '/clinic-manager/settings',
} as const;

/**
 * THE MANAGER'S PHONE STRIP — "‹ Reports ▸ Revenue · Aug", as every phone
 * board in this lane draws it. Spread into a page's chrome; the desk bar is
 * untouched. `search: false` is the boards' own choice: a report or a setting
 * on a phone has no search field.
 */
export function usePhoneCrumb(
  parent: keyof typeof PARENT,
  title: ReactNode,
  { search = false, back }: { search?: boolean; back?: string } = {},
): Pick<ShellChrome, 'phoneCrumb' | 'phoneTitle' | 'onPhoneBack' | 'phoneSearch' | 'panePhoneCrumb'> {
  const go = useNavigate();
  const { pathname } = useLocation();
  /* The report pages are mounted under /accountant too; back stays in the
     lane the screen was opened from. */
  const lane = pathname.startsWith('/accountant') && parent === 'Reports' ? '/accountant/reports' : null;
  return {
    phoneCrumb: parent,
    panePhoneCrumb: typeof title === 'string' ? `${parent} ▸ ${title}` : undefined,
    phoneTitle: title,
    onPhoneBack: () => go(back ?? lane ?? PARENT[parent]),
    phoneSearch: search,
  };
}
